import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ja from './locales/ja.json'
import vn from './locales/vn.json'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {
     ja:ja,
     vn:vn
  }
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: 'ja',
  fallbackLocale: 'vn',
  messages: loadLocaleMessages()
})
